import { useEffect, useState } from "react";
import { Flame, Loader2, Radio, Square, Trophy } from "lucide-react";
import { api } from "@/lib/api";

const Stat = ({ label, value, testid }) => (
  <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3" data-testid={testid}>
    <p className="font-display text-2xl font-extrabold tracking-tighter text-brand">{value}</p>
    <p className="text-[11px] uppercase tracking-widest text-ink-soft">{label}</p>
  </div>
);

// Sunday's look back: the week's reading and the longest run so far.
export const RecapCard = ({ speaker }) => {
  const [card, setCard] = useState(null);
  const sunday = new Date().getDay() === 0;

  useEffect(() => {
    if (!sunday) return;
    api.get("/news/recap").then(({ data }) => setCard(data)).catch(() => {});
  }, [sunday]);

  if (!sunday || !card) return null;
  const reading = speaker.playing === "recap";

  return (
    <div className="mt-3 rounded-3xl border border-white/10 bg-white/[0.03] p-5" data-testid="recap-card">
      <div className="flex flex-wrap items-center gap-2">
        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-ink-soft">
          <Trophy className="h-4 w-4 text-brand" /> Your week in news
        </p>
        <button
          data-testid="recap-listen"
          onClick={() => speaker.play("recap", async () => card.text)}
          className="ms-auto inline-flex min-h-[30px] items-center gap-1.5 rounded-full border border-white/10 px-3 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
        >
          {speaker.loading === "recap" ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : reading ? <Square className="h-3.5 w-3.5 text-brand" />
            : <Radio className="h-3.5 w-3.5 text-brand" />}
          {reading ? "Stop" : "Read it to me"}
        </button>
      </div>

      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
        <Stat label={`of ${card.goal} day goal`} value={card.read_days} testid="recap-days" />
        <Stat label="stories kept" value={card.saved} testid="recap-saved" />
        <Stat label="minutes of reading" value={card.minutes} testid="recap-minutes" />
        <Stat label="longest run" value={`${card.best}d`} testid="recap-best" />
      </div>

      <p className="mt-3 flex flex-wrap items-center gap-2 text-sm text-ink-soft">
        {card.streak > 0 && (
          <span className="inline-flex items-center gap-1 font-semibold text-brand" data-testid="recap-streak">
            <Flame className="h-4 w-4" /> {card.streak} day run
          </span>
        )}
        {card.papers.length > 0 && (
          <span data-testid="recap-papers">
            Mostly {card.papers.map((p) => p.source).join(", ")}
          </span>
        )}
        {card.goal_met && <span className="text-brand">Goal met — nicely done.</span>}
      </p>

      {card.titles.length > 0 && (
        <ul className="mt-2 space-y-1 text-xs text-ink-soft">
          {card.titles.map((title) => (
            <li key={title} dir="auto">{title}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
